export enum UserTypes {
    EDITOR = 'EDITOR',
    SUPER_EDITOR = 'SUPER_EDITOR',
    ADMIN = 'ADMIN',
}

export interface User {
    id: string
    key: string
    login: string
    password: string
    email: string
    passwordValidityDate: string
    rev: string
    roles?: UserTypes[]
    gdprAccepted?: boolean
    termsAndConditionsAccepted?: boolean
}

export type UserTypeKeys = keyof typeof UserTypes
